import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { sessionQuery } from '#admin/features/auth/queries.ts'
import { hasPlatformScope } from '#admin/features/platform/api.ts'
import { DomainsPanel } from '#admin/features/platform/tenants/domains-panel.tsx'
import { tenantQuery } from '#admin/features/platform/tenants/queries.ts'

/** `/platform/tenants/$tenantId/domains` — where the edition answers. */
export const Route = createFileRoute('/_authenticated/platform/tenants/$tenantId/domains')({
  staticData: { crumb: 'Domains' },
  component: DomainsTab,
})

function DomainsTab() {
  const { tenantId } = Route.useParams()
  const { data: tenant } = useSuspenseQuery(tenantQuery(tenantId))
  const { data: session } = useSuspenseQuery(sessionQuery())
  return (
    <DomainsPanel
      tenant={tenant}
      canManage={hasPlatformScope(session, 'platform:tenants.manage')}
    />
  )
}
